import { AppState } from "../../index";

export const getStateData = ({ membership: { active } }: AppState) => (active.status === "loaded" ? active.data : null);
